import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CriarPerfilComponent } from './criar-perfil/criar-perfil.component';
import { ListarPerfisComponent } from './listar-perfis/listar-perfis.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CmAngularOrgChartModule } from 'cm-angular-org-chart';
import { PerfilUnicoComponent } from './perfil-unico/perfil-unico.component';
import { NotificacoesPerfisComponent } from './notificacoes-perfis/notificacoes-perfis.component';
import { FormatCpfPipe, PerfisPipe } from './perfis.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { MostrarEditarPerfilComponent } from './mostrar-editar-perfil/mostrar-editar-perfil.component';
import { CriarUsuarioComponent } from './criar-usuario/criar-usuario.component';
import { GerenciarUsuariosPerfisComponent } from './gerenciar-usuarios-perfis/gerenciar-usuarios-perfis.component';

export const routes: Routes = [
  { path: '', component: ListarPerfisComponent },
  { path: 'criar-perfil', component: CriarPerfilComponent },
  { path: 'mostrar-editar-perfil', component: MostrarEditarPerfilComponent },
  {
    path: 'gerenciar-usuarios',
    component: GerenciarUsuariosPerfisComponent,
  },
];

@NgModule({
  declarations: [
    CriarPerfilComponent,
    ListarPerfisComponent,
    PerfilUnicoComponent,
    NotificacoesPerfisComponent,
    PerfisPipe,
    FormatCpfPipe,
    MostrarEditarPerfilComponent,
    CriarUsuarioComponent,
    GerenciarUsuariosPerfisComponent,


    // MatSpinnerOverlayComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CmAngularOrgChartModule,
    NgxPaginationModule,
  ],
})
export class PerfisModule {}
